import expand from './services/expand';

export default { expand };
